"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _VoicebaseReactPlayerContext = _interopRequireDefault(require("./VoicebaseReactPlayerContext"));

var _Icon = _interopRequireDefault(require("./common/Icon"));

var _Spin = _interopRequireDefault(require("./common/Spin"));

var _moment = _interopRequireDefault(require("moment"));

var _components = _interopRequireDefault(require("./styles/components"));

var _PanelStack = _interopRequireDefault(require("./common/Panel/PanelStack"));

var _analyticsParser = _interopRequireWildcard(require("./utilities/analytics-parser"));

var _appStateFactory = _interopRequireDefault(require("./utilities/appStateFactory"));

var _playerConstants = require("./common/playerConstants");

var _Player = _interopRequireDefault(require("./Player"));

var _ToastContainer = _interopRequireDefault(require("./Toaster/ToastContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parseExternalHits(externalHits) {
  if (!externalHits) {
    return [];
  }

  if (typeof externalHits === "string") {
    try {
      return parseExternalHits(JSON.parse(externalHits));
    } catch (err) {
      return [];
    }
  }

  return Array.isArray(externalHits) ? externalHits : [];
}

var DEFAULT_FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
var fullSize = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  minHeight: 0,
  background: "#f0f2f5",
  width: "100%",
  height: "100%"
};
var center = {
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignItems: "stretch"
};
var headerStyle = {
  height: "64px",
  padding: "0 50px",
  lineHeight: "64px",
  background: "white",
  color: "black",
  textAlign: "center",
  fontFamily: DEFAULT_FONT
};
var contentStyle = {
  flex: "auto",
  minHeight: 0,
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  fontFamily: DEFAULT_FONT
};
var errIconStyle = {
  color: "red",
  margin: "1rem",
  fontSize: "2.25rem",
  textAlign: "center"
};
/**
 *
 */

var VoicebaseReactPlayer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(VoicebaseReactPlayer, _React$Component);

  function VoicebaseReactPlayer(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "showToast", function (message, type) {
      _this.toastRef.current.addToast(message, type);
    });

    _this.toastRef = /*#__PURE__*/_react["default"].createRef(); // Create ref for ToastContainer

    return _this;
  } // static defaultProps = {
  //   analyticsFormat: ANALYTICS_SCHEMA_VERSION_V3,
  //   mediaUrl: "",
  //   analytics: false,
  //   loading: false,
  //   error: false,
  //   startTime: 0,
  //   children: "",
  //   advanceToFirstHit: 0,
  // };


  var _proto = VoicebaseReactPlayer.prototype;

  _proto.appFromAnalytics = function appFromAnalytics(media) {
    var _media$analyticsForma = media.analyticsFormat,
        analyticsFormat = _media$analyticsForma === void 0 ? _analyticsParser.ANALYTICS_SCHEMA_VERSION_V3 : _media$analyticsForma,
        _media$loading = media.loading,
        loading = _media$loading === void 0 ? false : _media$loading,
        _media$error = media.error,
        error = _media$error === void 0 ? false : _media$error,
        mediasToDisplay = media.mediasToDisplay,
        analytics = media.analytics,
        _media$mediaUrl = media.mediaUrl,
        mediaUrl = _media$mediaUrl === void 0 ? "" : _media$mediaUrl,
        externalHits = media.externalHits,
        _media$startTime = media.startTime,
        startTime = _media$startTime === void 0 ? 0 : _media$startTime,
        _media$advanceToFirst = media.advanceToFirstHit,
        advanceToFirstHit = _media$advanceToFirst === void 0 ? 0 : _media$advanceToFirst;
    var analyticsProps = (0, _analyticsParser["default"])(analyticsFormat, analytics);
    var appState = (0, _appStateFactory["default"])(analyticsProps);
    appState.view = {
      activeTab: _playerConstants.KEYWORDS_TAB
    };
    appState.startTime = startTime;
    appState.advanceToFirstHit = advanceToFirstHit;
    appState.externalHits = externalHits;
    (0, _lodash.get)(appState, "player", {}).mediaUrl = mediaUrl;
    return appState;
  }
  /**
   * accepts:
   * 1. a string
   * 2. an element
   * 3. an array of strings or elements
   */
  ;

  _proto.childrenToMessage = function childrenToMessage(children) {
    if (!Array.isArray(children)) return this.childToMessage(children);
    return children ? children.map(this.childToMessage) : "";
  };

  _proto.childToMessage = function childToMessage(child) {
    if (!child) return "";
    if ( /*#__PURE__*/_react["default"].isValidElement(child)) return child;
    if (typeof child === "string") return /*#__PURE__*/_react["default"].createElement("p", null, child);
    return "";
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        loading = _this$props.loading,
        error = _this$props.error,
        children = _this$props.children,
        isPCIFlagEnabled = _this$props.isPCIFlagEnabled,
        showPCIFlag = _this$props.showPCIFlag,
        handlePCIFlagClick = _this$props.handlePCIFlagClick,
        flagAction = _this$props.flagAction,
        handleMinimizePlayer = _this$props.handleMinimizePlayer,
        hidePlayer = _this$props.hidePlayer,
        medias = _this$props.medias,
        showPlayer = _this$props.showPlayer,
        updateLastPlayed = _this$props.updateLastPlayed,
        setActiveMedia = _this$props.setActiveMedia,
        _this$props$mediasToD = _this$props.mediasToDisplay,
        mediasToDisplay = _this$props$mediasToD === void 0 ? [] : _this$props$mediasToD,
        _this$props$isHostedA = _this$props.isHostedApp,
        isHostedApp = _this$props$isHostedA === void 0 ? false : _this$props$isHostedA,
        exportTranscript = _this$props.exportTranscript,
        mediaDownloadResponse = _this$props.mediaDownloadResponse;

    if (loading) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: fullSize
      }, /*#__PURE__*/_react["default"].createElement(_ToastContainer["default"], {
        ref: this.toastRef
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: headerStyle
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: {
          margin: 0
        }
      }, "Analytics Studio Player.")), /*#__PURE__*/_react["default"].createElement("div", {
        style: contentStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: center
      }, /*#__PURE__*/_react["default"].createElement(_Spin["default"], {
        size: "large",
        style: {
          margin: "1rem"
        }
      }), this.childToMessage(children))));
    }

    if (error) {
      var message = this.childrenToMessage(_react["default"].Children.toArray(children));
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: fullSize
      }, /*#__PURE__*/_react["default"].createElement(_ToastContainer["default"], {
        ref: this.toastRef
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: headerStyle
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Analytics Studio Player")), /*#__PURE__*/_react["default"].createElement("div", {
        style: contentStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: center
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        type: "exclamation-circle",
        theme: "filled",
        size: "huge",
        style: errIconStyle
      }), message)));
    }

    var simpleMediaPlayer = function simpleMediaPlayer(media) {
      var _media$analytics;

      var appState = _this2.appFromAnalytics(media);

      var interactionType = (0, _lodash.get)(appState, "parsedFromAnalytics.interactionType");
      var mediaId = (0, _lodash.get)(appState, "parsedFromAnalytics.mediaId");
      var transcriptLength = media === null || media === void 0 ? void 0 : (_media$analytics = media.analytics) === null || _media$analytics === void 0 ? void 0 : _media$analytics.length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ToastContainer["default"], {
        ref: _this2.toastRef
      }), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, appState, {
        key: mediaId,
        isPCIFlagEnabled: isPCIFlagEnabled,
        showPCIFlag: showPCIFlag,
        handlePCIFlagClick: handlePCIFlagClick,
        flagAction: flagAction,
        handleMinimizePlayer: handleMinimizePlayer,
        hidePlayer: hidePlayer,
        transcriptLength: transcriptLength,
        showToast: _this2.showToast
      })));
    };

    return /*#__PURE__*/_react["default"].createElement(_VoicebaseReactPlayerContext["default"].Provider, {
      value: {
        medias: medias,
        showPlayer: showPlayer,
        updateLastPlayed: updateLastPlayed,
        setActiveMedia: setActiveMedia,
        isHostedApp: isHostedApp,
        exportTranscript: exportTranscript,
        mediaDownloadResponse: mediaDownloadResponse
      }
    }, (mediasToDisplay === null || mediasToDisplay === void 0 ? void 0 : mediasToDisplay.length) ? /*#__PURE__*/_react["default"].createElement(_components["default"].GridCell, {
      stretch: true
    }, /*#__PURE__*/_react["default"].createElement(_PanelStack["default"], {
      isHostedApp: isHostedApp
    }, mediasToDisplay === null || mediasToDisplay === void 0 ? void 0 : mediasToDisplay.map(function (media, index) {
      var _media$analytics$meta, _media$analytics$meta2, _media$analytics$meta3, _media$analytics$meta4, _media$analytics2;

      var callStartTime = (0, _moment["default"])((_media$analytics$meta = media.analytics.metadata.callDetails) === null || _media$analytics$meta === void 0 ? void 0 : _media$analytics$meta.callStartTime).format("ll") || "unknown";
      var agentName = ((_media$analytics$meta2 = media.analytics.metadata) === null || _media$analytics$meta2 === void 0 ? void 0 : (_media$analytics$meta3 = _media$analytics$meta2.callDetails) === null || _media$analytics$meta3 === void 0 ? void 0 : (_media$analytics$meta4 = _media$analytics$meta3.agent) === null || _media$analytics$meta4 === void 0 ? void 0 : _media$analytics$meta4.fullName) || "unknown";
      var title = agentName + " on " + callStartTime;

      var appState = _this2.appFromAnalytics(media);

      var mediaId = (0, _lodash.get)(appState, "parsedFromAnalytics.mediaId");
      var transcriptLength = media === null || media === void 0 ? void 0 : (_media$analytics2 = media.analytics) === null || _media$analytics2 === void 0 ? void 0 : _media$analytics2.length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ToastContainer["default"], {
        ref: _this2.toastRef
      }), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, appState, {
        key: mediaId,
        isPCIFlagEnabled: isPCIFlagEnabled,
        showPCIFlag: showPCIFlag,
        handlePCIFlagClick: handlePCIFlagClick,
        flagAction: flagAction,
        handleMinimizePlayer: handleMinimizePlayer,
        hidePlayer: hidePlayer,
        title: title,
        isPlayer: true,
        transcriptLength: transcriptLength,
        showToast: _this2.showToast
      })));
    }))) : simpleMediaPlayer(this.props));
  };

  return VoicebaseReactPlayer;
}(_react["default"].Component);

_defineProperty(VoicebaseReactPlayer, "contextType", _VoicebaseReactPlayerContext["default"]);

VoicebaseReactPlayer.propTypes = process.env.NODE_ENV !== "production" ? {
  // Input Props
  analyticsFormat: _propTypes["default"].oneOf(_analyticsParser.AVAILABLE_ANALYTICS_SCHEMAS),
  mediaUrl: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  advanceToFirstHit: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  // Mapped Props
  analytics: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array, _propTypes["default"].bool])
} : {};
var _default = VoicebaseReactPlayer;
exports["default"] = _default;